module.exports = "../../app/cells/pages/question/related_questions_v2_cell.rb";